import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import $ from 'jquery';
import 'daterangepicker';
import 'daterangepicker/daterangepicker.css';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';

const NewBasicRangeShortcuts = ({ id, onDateChange }) => {
  const [localDateRange, setLocalDateRange] = useState({
    startDate: moment().subtract(29, 'days'),
    endDate: moment()
  });
  
  const repRangeRef = useRef(null);
  const initializedRef = useRef(false);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (initializedRef.current) return;
    initializedRef.current = true;

    const start = localDateRange.startDate;
    const end = localDateRange.endDate;

    function setActiveRange(label) {
      $('.ranges li').removeClass('active');
      $('.ranges li').each(function () {
        if ($(this).text().trim() === label) {
          $(this).addClass('active');
          return false;
        }
      });
    }

    function cb(start, end, label = 'Today') {
      $(repRangeRef.current)
        .find('span')
        .html(`${start.format('MMM D, YYYY')} - ${end.format('MMM D, YYYY')}`);
      
      const newRange = { startDate: start, endDate: end };
      setLocalDateRange(newRange);
      
      // Notify parent component
      if (onDateChange) {
        onDateChange(newRange);
      }

      const drp = $(repRangeRef.current).data('daterangepicker');
      if (label === 'Custom Range') drp.showCalendars();
      else drp.hideCalendars();

      setActiveRange(label);
    }

    const $picker = $(repRangeRef.current).daterangepicker(
      {
        startDate: start,
        endDate: end,
        maxDate: moment(),
        showCustomRangeLabel: true,
        alwaysShowCalendars: false,
        autoApply: false,
        opens: 'left',
        ranges: {
          'Today': [moment(), moment()],
          'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          'Last 7 Days': [moment().subtract(6, 'days'), moment()],
          'Last 30 Days': [moment().subtract(29, 'days'), moment()],
          'This Month': [moment().startOf('month'), moment().endOf('month')],
          'Last Month': [
            moment().subtract(1, 'month').startOf('month'),
            moment().subtract(1, 'month').endOf('month'),
          ],
          'All Time': [moment('2020-01-01'), moment()],
        },
        locale: {
          applyLabel: 'Apply',
          cancelLabel: 'Cancel',
        },
      },
      cb
    );

    // Initialize with default dates
    cb(start, end, 'Last 30 Days');

    // On picker open
    $(repRangeRef.current).on('click', function () {
      const drp = $(this).data('daterangepicker');
      if (drp) {
        drp.show();
        drp.hideCalendars();
        const currentStart = drp.startDate;
        const currentEnd = drp.endDate;

        let activeLabel = 'Custom Range';
        if (currentStart.isSame(moment(), 'day') && currentEnd.isSame(moment(), 'day')) {
          activeLabel = 'Today';
        } else if (
          currentStart.isSame(moment().subtract(1, 'days'), 'day') &&
          currentEnd.isSame(moment().subtract(1, 'days'), 'day')
        ) {
          activeLabel = 'Yesterday';
        } else if (
          currentStart.isSame(moment().subtract(6, 'days'), 'day') &&
          currentEnd.isSame(moment(), 'day')
        ) {
          activeLabel = 'Last 7 Days';
        } else if (
          currentStart.isSame(moment().subtract(29, 'days'), 'day') &&
          currentEnd.isSame(moment(), 'day')
        ) {
          activeLabel = 'Last 30 Days';
        } else if (
          currentStart.isSame(moment().startOf('month'), 'day') &&
          currentEnd.isSame(moment().endOf('month'), 'day')
        ) {
          activeLabel = 'This Month';
        } else if (
          currentStart.isSame(moment().subtract(1, 'month').startOf('month'), 'day') &&
          currentEnd.isSame(moment().subtract(1, 'month').endOf('month'), 'day')
        ) {
          activeLabel = 'Last Month';
        } else if (
          currentStart.isSame(moment('2020-01-01'), 'day') &&
          currentEnd.isSame(moment(), 'day')
        ) {
          activeLabel = 'All Time';
        }
        setActiveRange(activeLabel);
      }
    });

    // On range click
    $(document).on('click', '.ranges li', function () {
      const label = $(this).text().trim();
      const drp = $(repRangeRef.current).data('daterangepicker');
      setActiveRange(label);

      if (label === 'Custom Range') drp.showCalendars();
      else drp.hideCalendars();
    });

    // On Apply click
    $(repRangeRef.current).on('apply.daterangepicker', function (ev, picker) {
      const start = picker.startDate;
      const end = picker.endDate;

      let activeLabel = 'Custom Range';
      if (start.isSame(moment(), 'day') && end.isSame(moment(), 'day')) {
        activeLabel = 'Today';
      } else if (
        start.isSame(moment().subtract(1, 'days'), 'day') &&
        end.isSame(moment().subtract(1, 'days'), 'day')
      ) {
        activeLabel = 'Yesterday';
      } else if (
        start.isSame(moment().subtract(6, 'days'), 'day') &&
        end.isSame(moment(), 'day')
      ) {
        activeLabel = 'Last 7 Days';
      } else if (
        start.isSame(moment().subtract(29, 'days'), 'day') &&
        end.isSame(moment(), 'day')
      ) {
        activeLabel = 'Last 30 Days';
      } else if (
        start.isSame(moment().startOf('month'), 'day') &&
        end.isSame(moment().endOf('month'), 'day')
      ) {
        activeLabel = 'This Month';
      } else if (
        start.isSame(moment().subtract(1, 'month').startOf('month'), 'day') &&
        end.isSame(moment().subtract(1, 'month').endOf('month'), 'day')
      ) {
        activeLabel = 'Last Month';
      } else if (
        start.isSame(moment('2020-01-01'), 'day') &&
        end.isSame(moment(), 'day')
      ) {
        activeLabel = 'All Time';
      }

      setActiveRange(activeLabel);
    });

    // Show/hide events for active state
    $(repRangeRef.current).on('show.daterangepicker', () => setIsActive(true));
    $(repRangeRef.current).on('hide.daterangepicker', () => setIsActive(false));

    return () => {
      $picker.data('daterangepicker').remove();
      $(document).off('click', '.ranges li');
      $(repRangeRef.current).off('apply.daterangepicker');
      $(repRangeRef.current).off('show.daterangepicker');
      $(repRangeRef.current).off('hide.daterangepicker');
    };
  }, [onDateChange]);

  return (
    <div>
      <div
        ref={repRangeRef}
        id={id}
        className="reportrange badge text-sm fw-medium bg-light-100 px-12 py-10 radius-6 text-secondary-light d-flex justify-content-between align-items-center"
        style={{
          border: isActive ? '1px solid #2563eb' : '1px solid #d1d5db',
          borderRadius: '6px',
          padding: '6px 10px',
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          userSelect: 'none',
          backgroundColor: '#f9fafb',
          transition: 'all 0.2s ease-in-out',
          minWidth: '200px',
        }}
        onMouseEnter={(e) => {
          if (!isActive) {
            e.currentTarget.style.backgroundColor = '#f3f4f6';
            e.currentTarget.style.borderColor = '#9ca3af';
          }
        }}
        onMouseLeave={(e) => {
          if (!isActive) {
            e.currentTarget.style.backgroundColor = '#f9fafb';
            e.currentTarget.style.borderColor = '#d1d5db';
          }
        }}
      >
        <CalendarTodayOutlinedIcon sx={{ width: '18px', height: '18px' }} />
        <span></span>
        <KeyboardArrowDownOutlinedIcon sx={{ width: '18px', height: '18px' }} />
      </div>
    </div>
  );
};

export default NewBasicRangeShortcuts;